module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Text/H1-caac40bf2e0a81befc00160eea8e202a.svg";